import React from "react";
import { Link } from "react-router";
import {
  Container,
  Title,
  Text,
  Card,
  Group,
  Stack,
  Button,
  Center,
  Box,
} from "@mantine/core";

export default function HomePage() {
  return null;
}
